import { useMemo } from 'react';

import { createStateSelectorHook } from 'src/lib/sweetState';
import { VisualLanguageStore } from 'src/store/visualLanguage';

const useBrandVoiceState = createStateSelectorHook(VisualLanguageStore, [
  'workspaceVisualLanguages',
  'defaultVisualLanguageId',
]);

export const useVisualLanguages = () => {
  const { workspaceVisualLanguages, defaultVisualLanguageId } = useBrandVoiceState();

  return useMemo(() => {
    const defaultVisualLanguage = workspaceVisualLanguages.find(
      (item) => item.id === defaultVisualLanguageId
    );

    return {
      workspaceVisualLanguages,
      defaultVisualLanguage,
    };
  }, [workspaceVisualLanguages, defaultVisualLanguageId]);
};
